import 'base-app/index.css'
import React, { lazy, Suspense } from 'react'
import { FallbackSpinner, AppId } from 'base-app'
import en from './assets/translates/en.json'
import vi from './assets/translates/vi.json'
import { Route, Router, Switch } from 'react-router-dom'
import userGroupReducer from './redux/reducers/userGroup'
import buyInsuranceCarReducer from './redux/reducers/buyInsuranceCar'
import { combineReducers } from 'redux'
import { history } from './history'
import Insurance from './redux/reducers/Insurance'
import "./assets/scss/common.scss"
import feeInsuranceReducer from './redux/reducers/feeInsuManage'
import PaymentWaiting from './pages/buy-insurance/car/PaymentWaiting'
const App = () => {
  // Multi language messages
  const message = { en, vi }
  const BaseApp = lazy(() => import('./BasePage'))
  const CreateGroup = lazy(() => import('./pages/user-group/CreateGroup'))
  const Example = lazy(() => import('./Example'))
  const BuyInsurancePage = lazy(() => import('./pages/buy-insurance/BuyInsurancePage'))
  const InsuranceManageAllPage = lazy(() => import('./pages/vehicle-insurance-manage/InsuranceManageAllPage'))
  const VehicleInsuranceManageView = lazy(() => import('./pages/vehicle-insurance-manage/component/VehicleInsuranceManageView'))
  const InsuranceAppVIew = lazy(() => import( './pages/buy-insurance/motor/InsuranceAppVIew'))
  const BuyInsuranceCarView = lazy(() => import('./pages/buy-insurance/car/BuyInsuranceCarView'))
  const VehicleTemplateView = lazy(() => import('./pages/buy-insurance/car/VehicleTemplateView'))
  const InsuranceManagePersPage = lazy(() => import('./pages/vehicle-insurance-manage/InsuranceManagePersPage'))
  const InsuranceManagePartnerPage = lazy(() => import('./pages/vehicle-insurance-manage/InsuranceManagePartnerPage'))
  const FeeManageAllPage = lazy(() => import('./pages/manage-insurance-fee/FeeManageAllPage'))
  const FeeCarManageView = lazy(() => import('./pages/manage-insurance-fee/component/FeeCarManageView'))
  const FeeMotorManageView = lazy(() => import('./pages/manage-insurance-fee/component/FeeMotorManageView'))
  const FeeManageSystemPage = lazy(() => import('./pages/manage-insurance-fee/FeeManageSystemPage'))
  const FeeManageLXPartnerPage = lazy(() => import('./pages/manage-insurance-fee/FeeManageLXPartnerPage'))
  const FeeManagePersionalPage = lazy(() => import('./pages/manage-insurance-fee/FeeManagePersionalPage'))
  const FeeManagePartnerPage = lazy(() => import('./pages/manage-insurance-fee/FeeManagePartnerPage'))
  const FeeManageCustomerPage = lazy(() => import('./pages/manage-insurance-fee/FeeManageCustomerPage'))
  const FeeManageApprovePage = lazy(() => import('./pages/manage-insurance-fee/FeeManageApprovePage'))
  const FeePartnerConfigPage = lazy(() => import('./pages/manage-insurance-fee/FeePartnerConfigPage'))
  // const TestPage = lazy(() => import('./pages/buy-insurance-car/TestPage'))

  window.console.log = () => {}; // Remove console log

  const appReducer = combineReducers({
    userGroup: userGroupReducer,
    buyInsuranceCar: buyInsuranceCarReducer,
    Insurance:Insurance,
    feeInsuranceReducer: feeInsuranceReducer
  })


  return (
    <Suspense fallback={<FallbackSpinner />}>
      <BaseApp
        history={history}
        message={message}
        // apiBaseUrl={'https://apidev.inon.vn'}
        appId={AppId.DIVAY_INSURANCE_APP}
        appReducer={appReducer}
      >
        <Router history={history}>
          <Switch>
            <Route
              path='/permission-group/create'
              component={CreateGroup}
            ></Route>
            <Route exact path='/buy-insurance' component={BuyInsurancePage} />
            <Route path='/buy-insurance/car' component={BuyInsuranceCarView} />
            <Route path='/buy-insurance/motor' component={InsuranceAppVIew} />
            <Route path='/buy-insurance/vehicle/template' component={VehicleTemplateView } />
            <Route path='/gpayreturn' component={PaymentWaiting} />
            <Route
              exact
              path='/contracts/personal'
              component={InsuranceManagePersPage}
            ></Route>
            <Route
              exact
              path='/contracts/all'
              component={InsuranceManageAllPage}
            ></Route>
             <Route
              exact
              path='/contracts/partner'
              component={InsuranceManagePartnerPage}
            ></Route>
             <Route path='/contracts/vehicle' component={VehicleInsuranceManageView} />
            
             <Route
              exact
              path='/insurance-fee/system'
              component={FeeManageSystemPage}
            ></Route>
             <Route
              exact
              path='/insurance-fee/all'
              component={FeeManageAllPage}
            ></Route>
             <Route
              exact
              path='/insurance-fee/lx-partner'
              component={FeeManageLXPartnerPage}
            ></Route>
            <Route
              exact
              path='/insurance-fee/personal'
              component={FeeManagePersionalPage}
            ></Route>
             <Route
              exact
              path='/insurance-fee/partner'
              component={FeeManagePartnerPage}
            ></Route>
            <Route
              exact
              path='/insurance-fee/customer'
              component={FeeManageCustomerPage}
            ></Route>
            <Route path='/insurance-fee/feeCar' component={FeeCarManageView} />
            <Route path='/insurance-fee/feeMotor' component={FeeMotorManageView} />
            <Route
              exact
              path='/insurance-fee/approval'
              component={FeeManageApprovePage}
            ></Route>
             <Route
              exact
              path='/insurance-fee/fee-partner-config'
              component={FeePartnerConfigPage}
            ></Route>
            <Route exact path='/'></Route>
          </Switch>
        </Router>
      </BaseApp>
    </Suspense>
  )
}

export default App
